// Thank's IE8 for his funny defineProperty
module.exports = !require('../internals/descriptors') && !require('../internals/fails')(function () {
  return Object.defineProperty(require('../internals/document-create-element')('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/ie8-dom-define.js
// module id = 337
// module chunks = 0